import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface ContainerProps {
    children: ReactNode
    className?: string
    as?: 'div' | 'section' | 'header' | 'footer' | 'main'
}

export const Container: FC<ContainerProps> = ({ children, className, as: Tag = 'div' }): ReactNode => {
    return (
        <Tag className={cn('mx-auto w-full max-w-6xl px-5 sm:px-6 lg:px-8', className)}>
            {children}
        </Tag>
    )
}
